/**
 * 共通ユーティリティ.
 */
module.exports = {
  /**
   * 正規表現.
   */
  regex: {
    numerical: /^[0-9]+$/,
    numerical_minus: /^[-]?[0-9]+$/,
    decimal: /^[0-9]+(\.[0-9]+)?$/,
    decimal_minus: /^[-]?[0-9]+(\.[0-9]+)?$/,
    time: /^([01][0-9]|2[0-3]):([0-5][0-9])$/,
    post_no: /^[0-9]{3,10}$/,
    post_no_3_7: /^[0-9]{3,7}$/,
    tel: /^[0-9-]+$/,
    phone: /^\d{1,4}-?\d{1,4}-?\d{1,4}$/,
    email: /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
    hiragana: /^[\u3040-\u309f\u0020\u00a0\u3000\u30fb\u30fc]+$/ // ひらがな 半角空白 全角空白 中点・ 長音符ー
  },
  /**
   * 最下部スクロールイベント.
   * ※注意： '更に読み込む' ボタン等に 'next-page-search-btn' クラスを付与してください.
   */
  scrollBottomSearchEvent: function (callback, callbackParam, nextPageElem) {
    var block = true
    var body = null
    // イベント削除
    this.scrollBottomSearchEventRemove()
    // ロード
    var didRender = function () {
      body = document.getElementsByTagName('body')[0]
    }
    // スクロール
    var onScroll = function () {
      if (body === null || body === undefined) {
        didRender()
      } else {
        // 最下部に達した場合
        var target = /BackCompat/i.test(document.compatMode) ? document.body : document.documentElement
        var scrollTop = window.pageYOffset || target.scrollTop
        if (target.scrollHeight - scrollTop <= target.clientHeight + 100) {
          // 更に読み込むボタンがある場合
          if (document.querySelectorAll(nextPageElem).length > 0) {
            if (block) {
              block = false
              callback(callbackParam)
            }
          }
        } else {
          block = true
        }
      }
    }
    window.scrollBottomSearchDidRender = function () { didRender() }
    window.scrollBottomSearchOnScroll = function () { onScroll() }
    window.addEventListener('load', window.scrollBottomSearchDidRender, false)
    window.addEventListener('scroll', window.scrollBottomSearchOnScroll, false)
  },
  /**
   * 最下部スクロールイベント削除.
   */
  scrollBottomSearchEventRemove: function () {
    if (window.scrollBottomSearchDidRender) {
      window.removeEventListener('load', window.scrollBottomSearchDidRender, false)
    }
    if (window.scrollBottomSearchOnScroll) {
      window.removeEventListener('scroll', window.scrollBottomSearchOnScroll, false)
    }
  },
  /**
   * 空白確認.
   * @param val 値
   * @param isTrim 空白を除外して評価 ※省略可 デフォルト空白除去評価しない
   * @return boolean
   */
  isBlank: function (val, isTrim) {
    // デフォルト
    if (typeof isTrim === 'undefined') {
      isTrim = false // 空白除去評価
    }

    if (typeof val === 'undefined' || val === null || val === '') {
      return true
    }
    if (isTrim && ('' + val).trim() === '') {
      return true
    }
    return false
  },
  /**
   * メールアドレスチェック.
   * @param val
   * @param isBlankPass 空白時にOKとするか ※省略可 デフォルト空白OK
   * @return boolean
   */
  isEmail: function (val, isBlankPass) {
    // デフォルト
    if (this.isBlank(isBlankPass)) {
      isBlankPass = true
    }
    // 空白
    if (this.isBlank(val)) {
      return isBlankPass
    }

    // 正規表現チェック
    if (this.regex.email.test(val)) {
      return true // OK
    }

    return false // NG
  },
  isPresent: function (val, isTrim) {
    return !this.isBlank(val, isTrim)
  },
  isPostNo: function (val, isBlankPass) {
    if (this.isBlank(isBlankPass)) {
      isBlankPass = true
    }
    if (this.isBlank(val)) {
      return isBlankPass
    }
    if (this.regex.post_no_3_7.test(val)) {
      return true
    }

    return false
  },
  emHalf: function (str) {
    var halfVal = str.replace(/[Ａ-Ｚａ-ｚ０-９]/g,
      function (tmpStr) {
        return String.fromCharCode(tmpStr.charCodeAt(0) - 0xFEE0)
      })
    return halfVal
  },
  backClear: function () {
    window.sessionStorage.removeItem('BackPage')
    window.sessionStorage.removeItem('retiree')
    window.sessionStorage.removeItem('moral_result')
  },
  moralBackClear: function () {
    window.sessionStorage.removeItem('moral_result')
  },
  kebabSnakeConversion (itemObj) {
    return Object.keys(itemObj).reduce((acc, key) => {
      let newKey = key
      newKey = key.replace(/-/g, () => { return '_' })
      acc[newKey] = itemObj[key]
      return acc
    }, {})
  }
}



// WEBPACK FOOTER //
// ./src/utils.js